import styled, { css } from 'styled-components';
import { Box, Button as BaseButton } from '@rsos/components/capstone/base';
import AED_STATUS from './aviveStatusTypes';

export const StyledAviveStatus = styled(Box)`
  padding: 12px 20px;
  border-radius: 5px;
  margin-bottom: 5px;
  ${({ status }) => {
    switch (status) {
      case AED_STATUS.PENDING:
        return css`
          background: ${({ theme }) => theme.colors.primaryBase};
          color: ${({ theme }) => theme.colors.background};
        `;
      case AED_STATUS.FAILURE:
        return css`
          background: ${({ theme }) => theme.colors.lightDanger};
          color: ${({ theme }) => theme.colors.background};
        `;
      case AED_STATUS.SUCCESS:
        return css`
          background: ${({ theme }) => theme.colors.success};
          color: ${({ theme }) => theme.colors.background};
        `;
    }
  }};
`;
const AVIVE_BRAND_COLOR = '#ff4f50';
export const StyledIcon = styled(Box)`
  display: inline-flex;
  margin-right: 10px;
  position: relative;
  color: ${({ brand, theme }) =>
    brand ? AVIVE_BRAND_COLOR : theme.colors.background};

  ${({ brand }) =>
    brand &&
    `
    top: -3px;
    left: -3px;
  `}
`;

export const Button = styled(BaseButton)`
  width: 122px;
`;
